// removed by extract-text-webpack-plugin
module.exports = {"center":"center__3GPFwwUkGB8O"};